@import '../styles/palette.scss';

.marginFormElements {
  margin: 8px;
}

.iconLine {
  * {
    vertical-align: middle;
  }

  p {
    display: inline-block;
  }
}

.buttonContainer {
  display: flex;
  float: right;

  button {
    margin-right: 20px;
  }
}

.permissionButtonContainer {
  text-align: right;

  button {
    margin: 1em 0.5em 0 1em;
  }
}

.container {
  $aboutMeMarginTop: 16px;
  background-color: _palette(card);
  border: 1px solid _palette(border-strong);
  border-radius: 5px;
  margin-top: 40px;
  padding: 20px 0;

  &.editMode {
    background-color: _palette('bg-primary');
  }

  .label {
    font-size: 16px;
    font-weight: 600;
  }

  .profilePicture {
    border-radius: 50%;
    margin-left: 16px;
    padding: 1px;
    width: 80%;
  }

  .profilePictureReplacement {
    background-color: _palette(primary);
    border-radius: 50%;
    color: white;
    font-size: 24px;
    font-weight: 600;
    margin: auto;
    text-align: center;
  }

  .name {
    font-size: 24px;
    font-weight: 700;
  }

  .aboutMeHeader {
    color: _palette(secondary);
    display: block;
    font-size: 18px;
    font-weight: 700;
    margin-top: #{$aboutMeMarginTop};
  }

  .aboutMeText {
    margin-top: #{$aboutMeMarginTop};
    white-space: pre;

    > div:first-child {
      width: 100%;
    }
  }

  hr {
    background-color: _palette(text-disabled); /* Modern Browsers */
    border: none;

    /* Set the hr color */
    color: _palette(text-disabled); /* old IE */
    height: 1px;
    line-height: 0.1em;

    margin-top: calc(11px + #{$aboutMeMarginTop});
  }

  input {
    background-color: _palette('bg-secondary');
    padding: 4px;
    width: 170px;
  }

  textarea {
    border: 1px solid _palette('black-25');
    border-radius: 5px;
    font-size: 16px;
    height: 150px;
    padding: 4px;
    width: 100%;
  }

  @media screen and (max-width: 479px) {
    .profilePictureReplacement {
      display: none;
    }
  }

  @media screen and (min-width: 480px) and (max-width: 599px) {
    .profilePictureReplacement {
      height: 70px;
      padding-top: 18px;
      width: 70px;
    }
  }

  @media screen and (min-width: 600px) and (max-width: 767px) {
    .profilePictureReplacement {
      height: 100px;
      padding-top: 30px;
      width: 100px;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 899px) {
    .profilePictureReplacement {
      font-size: 32px;
      height: 140px;
      padding-top: 46px;
      width: 140px;
    }
  }

  @media screen and (min-width: 900px) and (max-width: 1023px) {
    .profilePictureReplacement {
      font-size: 40px;
      height: 180px;
      padding-top: 60px;
      width: 180px;
    }
  }

  @media screen and (min-width: 1024px) {
    .profilePictureReplacement {
      font-size: 48px;
      height: 200px;
      padding-top: 62px;
      width: 200px;
    }
  }
}

.omMegHelpText {
  background: #fff;
  border: 1px solid _palette(border-black-10);
  border-radius: 4px;
  margin: 20px 8px;
  width: 100%;

  .icon {
    display: inline-block;
    vertical-align: top;
  }

  .text {
    display: inline-block;
    padding: 15px 0;
  }

  ol {
    margin-top: 0.3em;
  }

  svg {
    color: _palette(input-border-outlined);
    margin: 15px;
  }
}

.privileges {
  .rolleSelect {
    width: 200px;
  }

  .tilgangSelect {
    width: 400px;
  }

  thead {
    th {
      font-size: 11pt;
      font-weight: 600;
    }
  }

  tbody {
    tr:nth-child(odd) {
      background-color: _palette(text-white-secondary);
    }

    tr:nth-child(even) {
      background-color: _palette(bg-primary);
    }

    .editRow td {
      background-color: _palette(bg-secondary);
    }

    tr:hover {
      background-color: _palette(bg-secondary);

      td {
        color: _palette(text-data-changed);
      }
    }
  }
}

.activities {
  .header {
    h2 {
      span {
        color: _palette(secondary);
      }
    }
  }
}

.stedNavnCell {
  display: flex;
}
